import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatUsDate } from '../util/formatters';
import { CollapsibleCard } from './CollapsibleCard';
import { InfoField } from './InfoField';
const formatBool = (b) => b === undefined ? undefined : b ? 'Yes' : 'No';
// "Autohost verified" is the operator-friendly roll-up: both ID verification
// AND terms acceptance must be present and true. Surface the boolean so the
// operator doesn't have to mentally combine the two sub-fields.
const isAutohostVerified = (additionalEvidence) => {
    const id = additionalEvidence.idVerification;
    const toc = additionalEvidence.tocAcceptance;
    if (!id || !toc) {
        return undefined;
    }
    if (id.verified === undefined && toc.accepted === undefined) {
        return undefined;
    }
    return (id.verified ?? false) && (toc.accepted ?? false);
};
export const AutohostDetailsCard = ({ additionalEvidence }) => {
    if (!additionalEvidence) {
        return null;
    }
    const id = additionalEvidence.idVerification;
    const toc = additionalEvidence.tocAcceptance;
    if (!id && !toc) {
        return null;
    }
    return (_jsx(CollapsibleCard, { title: "Autohost Details", children: _jsxs("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-3", children: [_jsx(InfoField, { label: "ID verified", value: formatBool(id?.verified) }), _jsx(InfoField, { label: "ID verified date", value: id?.verifiedAt ? formatUsDate(id.verifiedAt) : undefined }), _jsx(InfoField, { label: "Terms accepted", value: formatBool(toc?.accepted) }), _jsx(InfoField, { label: "Terms accepted date", value: toc?.acceptedAt ? formatUsDate(toc.acceptedAt) : undefined }), _jsx(InfoField, { label: "Autohost verified", value: formatBool(isAutohostVerified(additionalEvidence)) })] }) }));
};
